export const CONTENTS_CONTAINER_SELECTOR = '.contents'
